// Older 3ds Max exporters can keep the active texture wiring exclusively in
// vendor properties. ufbx exposes those connections but does not normalize all
// of them into material.fbx/pbr maps. Respect explicit enable flags, and never
// guess a material assignment from the names of loose images.
export function resolveLegacyMaterialTextures(material, textures, warnings) {
    const channels = Object.fromEntries(["color", "emission", "normal", "ao", "opacity"].map(key => [key, material[key].texture]));
    let diffuseReplacesColor = false, normalStrength = 1;
    for (const connection of material.connections ?? []) {
        const match = /^3dsMax\|maps\|texmap_(.+)$/i.exec(connection.property);
        if (!match || !connection.enabled || connection.weight === 0) continue;
        const slot = match[1].toLowerCase();
        const channel = { diffuse: "color", self_illumination: "emission", opacity: "opacity", normal: "normal", bump: "normal" }[slot];
        if (!channel) {
            warnings.add(`${material.name}: 3ds Max ${slot} texture requires shader conversion/baking and was omitted.`);
            continue;
        }
        if (channels[channel] >= 0 || material[channel].disabledTexture) continue;
        const texture = textures[connection.texture];
        if (slot === "bump" && !/(?:^|[\\/_. -])(?:normal|normals|nrm|nor)(?:[_. -]|$)/i.test(texture?.file ?? "")) {
            warnings.add(`${material.name}: the 3ds Max bump texture is not identified as a normal map; bake it to a normal map before importing.`);
            continue;
        }
        channels[channel] = connection.texture;
        if (channel === "color") {
            // At 100% map amount, Max replaces diffuse color with the texture.
            // Treating the exported grey fallback as a tint darkens the image.
            diffuseReplacesColor = true;
            if (connection.weight !== 1) warnings.add(`${material.name}: the diffuse texture blend was approximated using the full texture.`);
        }
        if (channel === "normal") normalStrength = connection.weight;
    }
    return { channels, diffuseReplacesColor, normalStrength };
}
